export const LAST_CONTACT_DETAIL_KEY = 'lastContactDetails'

export const CONTACT_ORIGINS = {
  POST_FAVORITE: 'POST_FAVORITE'
}
